module.exports = __webpack_public_path__ + "json/market8-0.json?4e08d2de738ef5e403b60e39631175c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market8-0.json
// module id = 1269
// module chunks = 3